document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll(".product-collapsible-widget");

    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".product-collapsible-widget__content");
        accordion.classList.add("open");
        content.style.maxHeight = content.scrollHeight + "px";
    };

    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".product-collapsible-widget__content");
        accordion.classList.remove("open");
        content.style.maxHeight = null;
    };

    accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".product-collapsible-widget__header");
        const content = accordion.querySelector(".product-collapsible-widget__content");

        intro.onclick = () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion));
                openAccordion(accordion);
            }
        };
    });

 // IMAGE ZOOM
if (window.innerWidth > 768) {
  var paneContainer = document.querySelector('.product-page__content');

  function initDriftZoom() {
    document.querySelectorAll('.mobile-zoom-wrapper').forEach(wrapper => {
      const img = wrapper.querySelector('img');

      if (!img) return;

      if (!img.getAttribute('data-zoom')) {
        img.setAttribute('data-zoom', img.getAttribute('src'));
      }

      if (!img.classList.contains('drift-zoomed')) {
        new Drift(img, {
          inlinePane: true,
          containInline: true,
          inlinePane: 768,
          zoomFactor: 2
        });

        img.classList.add('drift-zoomed');
      }
    });
  }

  const observer = new MutationObserver(() => {
    const zoomEls = document.querySelectorAll(
      '.mobile-zoom-wrapper img:not(.drift-zoomed)'
    );

    if (zoomEls.length > 0) {
      initDriftZoom();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(initDriftZoom, 1000);
}
  // IMAGE POPUP
    const mediaEls = document.querySelectorAll('.product__media');

  if (!mediaEls.length) return;

  const galleryItems = [];

  mediaEls.forEach((mediaEl, index) => {
    const imgProduct = mediaEl.querySelector('img');
    if (!imgProduct) return;

    const src = imgProduct.getAttribute('src');
    if (!src) return;

   
    galleryItems.push({
      src: src,
      type: 'image'
    });

   
    mediaEl.addEventListener('click', function () {
      Fancybox.show(galleryItems, {
        startIndex: index,
        Thumbs: false,
        Toolbar: {
          display: ["close"]
        }
      });
    });
  });

  if (window.innerWidth > 768) {
    const element = document.querySelector('.product-page__virtual-try-mobile');
    const newContainer = document.querySelector('.product-page__images-wrap');

    if (element && newContainer) {
      newContainer.appendChild(element); 
    }
    element.style.marginTop = '90px';
  }
  document.querySelectorAll('[data-product-video]').forEach((wrapper) => {
  const thumbnail = wrapper.querySelector('[data-video-thumbnail]');
  const video = wrapper.querySelector('video');
  const youtube = wrapper.querySelector('.product-video-youtube');

  if (!thumbnail) return;

  thumbnail.addEventListener('click', () => {
    thumbnail.style.display = 'none';

    if (video) {
      video.classList.remove('hidden');
      video.play();
    }

    if (youtube) {
      youtube.classList.remove('hidden');

      const iframe = youtube.querySelector('iframe');

      if (iframe) {
        const separator = iframe.src.includes('?') ? '&' : '?';
        iframe.src += `${separator}autoplay=1`;
      }
    }
  });
});
});

 (() => {
        function init(root) {
            root.querySelectorAll('.product-page__images-wrap').forEach((wrap) => {
                const bar = wrap.querySelector('.mobile-gallery-progress');
                const slider = wrap.querySelector('[data-product-slideshow]');
                if (!bar || !slider || bar.galleryProgressObserver) return;
                const fill = bar.querySelector('.mobile-gallery-progress__fill');
                let queued = false;
                const update = () => {
                    queued = false;
                    const instance = (window.Flickity && window.Flickity.data(slider)) ||
                        (window.jQuery && window.jQuery(slider).data('flickity'));
                    let total, index;
                    if (instance && instance.slides && instance.slides.length) {
                        total = instance.slides.length;
                        index = instance.selectedIndex;
                    } else {
                        const track = slider.querySelector('.flickity-slider');
                        const cells = track ? Array.from(track.children).filter((cell) =>
                            !cell.hidden && getComputedStyle(cell).display !== 'none'
                        ) : [];
                        const thumbs = Array.from(wrap.querySelectorAll('[data-slideshow-thumbnail]')).filter((thumb) =>
                            !thumb.hidden && thumb.getAttribute('aria-hidden') !== 'true' && getComputedStyle(thumb).display !== 'none'
                        );
                        const items = cells.length ? cells : thumbs;
                        total = items.length;
                        index = items.findIndex((item) => item.matches('.is-selected, .is-activated, .is-active, [aria-current="true"]'));
                    }
                    if (!total) return;
                    index = Math.max(0, Math.min(index || 0, total - 1));
                    const width = ((index + 1) / total * 100) + '%';
                    if (fill.style.width !== width) fill.style.width = width;
                    if (bar.getAttribute('aria-valuemax') !== String(total)) bar.setAttribute('aria-valuemax', total);
                    if (bar.getAttribute('aria-valuenow') !== String(index + 1)) bar.setAttribute('aria-valuenow', index + 1);
                    if (bar.hidden !== (total < 2)) bar.hidden = total < 2;
                };
                const observer = new MutationObserver(() => {
                    if (!queued) { queued = true; requestAnimationFrame(update); }
                });
                observer.observe(wrap, { subtree: true, childList: true, attributes: true,
                    attributeFilter: ['class', 'style', 'hidden', 'aria-current', 'aria-hidden'] });
                bar.galleryProgressObserver = observer;
                update();
            });
        }
        if (!window.mobileGalleryProgressInitialized) {
            window.mobileGalleryProgressInitialized = true;
            document.addEventListener('shopify:section:load', (event) => init(event.target));
            document.addEventListener('shopify:section:unload', (event) => {
                event.target.querySelectorAll('.mobile-gallery-progress').forEach((bar) => {
                    if (bar.galleryProgressObserver) bar.galleryProgressObserver.disconnect();
                });
            });
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
        else init(document);
    })();

      (() => {
        // Capture clicks before theme handlers can stop propagation.
        if (window.productMobileGalleryArrowHandler) {
            document.removeEventListener('click', window.productMobileGalleryArrowHandler, true);
        }
        window.productMobileGalleryArrowHandler = (event) => {
            const button = event.target.closest('[data-mobile-gallery-dir]');
            if (!button) return;
            const gallery = button.closest('.product-mobile-gallery');
            const slider = gallery.querySelector('[data-product-slideshow]');
            if (!slider) return;
            event.preventDefault();
            event.stopPropagation();
            const direction = button.dataset.mobileGalleryDir;
            const instance = (window.Flickity && window.Flickity.data(slider)) ||
                (window.jQuery && window.jQuery(slider).data('flickity'));
            if (instance && typeof instance[direction] === 'function') {
                instance[direction](true);
                return;
            }
            // Some themes keep Flickity private. Reuse their thumbnail navigation.
            const holder = gallery.parentElement.querySelector('[data-product-thumbs]');
            const thumbs = holder ? Array.from(holder.querySelectorAll('[data-slideshow-thumbnail]')).filter((thumb) =>
                !thumb.hidden && thumb.getAttribute('aria-hidden') !== 'true' &&
                getComputedStyle(thumb).display !== 'none'
            ) : [];
            if (thumbs.length > 1) {
                let index = thumbs.findIndex((thumb) =>
                    thumb.classList.contains('is-activated') ||
                    thumb.classList.contains('is-active') ||
                    thumb.classList.contains('is-selected') ||
                    thumb.getAttribute('aria-current') === 'true'
                );
                if (index < 0) index = 0;
                const next = (index + (direction === 'previous' ? -1 : 1) + thumbs.length) % thumbs.length;
                thumbs[next].click();
                return;
            }
            const nativeArrow = slider.querySelector('.flickity-prev-next-button.' + direction);
            if (nativeArrow) nativeArrow.click();
        };
        document.addEventListener('click', window.productMobileGalleryArrowHandler, true);
    })();